import type { ReactNode } from 'react';

interface BarraFixaProps {
  visivel?: boolean;
  children: ReactNode;
}

// Rodapé fixo com total + ação, respeitando a área segura do iPhone.
export default function BarraFixa({ visivel = true, children }: BarraFixaProps) {
  if (!visivel) return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 px-4 pb-4"
      style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
    >
      <div className="mx-auto flex w-full max-w-[720px] items-center gap-3 rounded-2xl bg-white/90 p-3 shadow-xl backdrop-blur-md">
        {children}
      </div>
    </div>
  );
}